import { ids as stageIds } from '../../stage/Id';

export const ids = [
	...stageIds,
	'job-owner',
	'qa-person',
	'team-leader',
	'chat',
	'assignee',
] as const;
